type Props = {
  readonly onChange: (color: string) => void;
};

const PRESET_COLORS = [
  "#b02318",
  "#eb3323",
  "#f6c243",
  "#feff54",
  "#9fcf63",
  "#4eae5b",
  "#4eadea",
  "#2d6eba",
  "#08215b",
  "#68349a",
];

export const PresetColorPicker = ({ onChange }: Props) => {
  return (
    <div className="flex flex-row space-x-2">
      {PRESET_COLORS.map((c) => (
        <div
          key={`preset-color-${c}`}
          className="h-[20px] w-[20px] cursor-pointer"
          style={{ backgroundColor: c }}
          onClick={() => {
            onChange(c);
          }}
        />
      ))}
    </div>
  );
};
